'use strict';

DoohApps
.service('CompanyBLL', ['CompanyActionsData', 'ReportData', 'CompanyData', 'PersonsData', 'Account',
    function (CompanyActionsData, ReportData, CompanyData, PersonsData, Account) {

    this.GetCompanyActionsList = function (callback, filter) {
        CompanyActionsData.getCompanyActionList(function (data) { getActions(callback, data) }, filter);
    }

    //Callback functions///////
    function getActions(callback, data) {
        var ActionList = data.Data.Content;

        if (ActionList.length != 0) {
            for (var action = 0; action < ActionList.length; action++) {

                switch (ActionList[action].Category) {
                    case 'App Inbox':
                        var descr = ActionList[action].Description;
                        var searchFor = encodeURIComponent(descr.split(/"/)[1]);
                        if (ActionList[action].Action == '-') {
                            ActionList[action].Actions = {
                                url: '',
                                text: ActionList[action].Action
                            }
                        }
                        else if (ActionList[action].Action == 'Schedule') {
                            ActionList[action].Actions = {
                                url: ActionList[action].ReferenceID,
                                text: 'Schedule now'
                            }
                        }
                        else {
                            ActionList[action].Actions = {
                                url: '/ToolBox/AppInbox?Search=' + searchFor + '&Campaign=' + ActionList[action].ReferenceID,
                                text: ActionList[action].Action
                            }
                        }

                        break;
                    case 'Media Assets':
                    case 'My assets':
                        if (ActionList[action].Action == '-') {
                            ActionList[action].Actions = {
                                url: '',
                                text: ActionList[action].Action
                            }
                        }
                        else if (ActionList[action].Action == 'assets') {
                            ActionList[action].Actions = {
                                url: '/ToolBox/MediaAssets',
                                text: 'Go to media assests'
                            }
                        }
                        break;
                }
            }
        }
        callback(ActionList);

    }

    this.addCompany = function (callback, company) {
        CompanyData.addCompany(function (data) { callback(data) }, company);
    }
    this.updateCompany = function (callback, company) {
        CompanyData.updateCompany(function (data) { callback(data) }, company);
    }

    this.updateUser = function (callback, person) {
        PersonsData.updatePerson(function (data) { responseHandler(callback, data) }, person);
    }

    this.deleteUser = function (callback, personid) {
        PersonsData.deletePerson(function (data) { callback(data) }, personid);
    }

    this.updateUserStatus = function (callback, person) {
        Account.updatePersonStatus(function (data) { responseHandler(callback, data) }, person);
    }

    this.getAllCompanyList = function (callback) {
        CompanyData.getAllCompanyList(function (data) { responseHandler(callback, data) });
	}

    this.getVendorList = function (callback) {
        CompanyData.getCompanyList(function (data) { returnContent(callback, data) });
    }

    this.getPersonList = function (callback, filterOptions) {
        PersonsData.getPersonList(function (data) { responseHandler(callback, data) }, filterOptions);
    }

    this.getTimeZones = function (callback) {
        PersonsData.getTimeZones(function (data) { responseHandler(callback, data) });
    }

    this.getIANATimeZone = function (callback, windowsId) {
        PersonsData.getIANATimeZone(function (data) { callback(data) }, windowsId)
    }

    this.getCompanyData = function (callback, filter) {
        CompanyData.getCompanyData(function (data) { responseHandler(callback, data) }, filter);
    }
    this.companyDeleteCheck = function (callback, id) {
        CompanyData.companyDeleteCheck(function (data) { responseHandler(callback, data) }, id)
    }
    this.deleteCompany = function (callback, id) {
        CompanyData.deleteCompany(function (data) { responseHandler(callback, data) }, id);
    }

    //-----Report section----------
    this.getReports = function (callback) {
        ReportData.getReportData(function (data) { returnContent(callback, data) });
    }

    this.saveReport = function (callback, report) {
        if (report.ReportID != 0) {
            ReportData.updateReport(function (data) { callback('Report saved!') }, report);
        }
        else {
            ReportData.addReport(function (data) { callback('Report saved!') }, report);
        }
    }

    this.deleteReport = function (callback, rep) {
        ReportData.deleteReport(function (data) { callback('Report deleted!') }, rep.ReportID);
    }

    function returnContent(callback, data) {
        callback(data.Data.Content);
    }

    function responseHandler(callback, data) {
                callback({
                    hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                    error: getErrorMessage(data),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                });
            }

    function getErrorMessage(data) {
        if (data.hasError)
            return data.errors[0];

        return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
    }
}]);